import React, { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const THEME = {
  triggerOpen: "border-[#86D4A4] ring-2 ring-[rgba(134,239,172,0.35)]",
  triggerIdle: "border-[#DADDE1] hover:border-[#86D4A4]",
};

function ThemeRadio({ checked }) {
  return (
    <span
      className={`w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${
        checked ? "border-gray-900" : "border-gray-400"
      }`}
    >
      {checked && (
        <span className="w-2 h-2 rounded-full bg-gray-900" />
      )}
    </span>
  );
}

/**
 * Single-select time range filter — matches Templates page theme.
 */
export default function TemplateTimeRangeFilter({
  value = null,
  options = [],
  onChange,
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const selectedLabel =
    options.find((o) => o.id === value)?.label ||
    options.find((o) => o.id === null)?.label ||
    "All time";

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`tpl-fchip ${open ? THEME.triggerOpen : THEME.triggerIdle}${value != null ? " on" : ""}`}
      >
        <span className="truncate">{selectedLabel}</span>
        <ChevronDown
          size={16}
          className={`text-gray-500 shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          className="tpl-fmenu absolute right-0 z-50 mt-2 min-w-[200px] overflow-hidden py-1"
        >
          {options.map((opt) => {
            const checked = value === opt.id;
            return (
              <button
                key={String(opt.id)}
                type="button"
                onClick={() => {
                  onChange(opt.id);
                  setOpen(false);
                }}
                className={`tpl-fopt${checked ? " on" : ""}`}
              >
                <ThemeRadio checked={checked} />
                <span className="text-gray-800">{opt.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
